<template>
  <div>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title>Сброс пароля</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text class="mr-2" @click="$router.go(-1)">
        <span class="mr-2">Вернуться назад</span>
      </v-btn>
    </v-app-bar>

    <v-dialog persistent v-model="isOpen" width="500">
      <v-card>
        <v-card-title>
          Сброс пароля
        </v-card-title>

        <v-card-text class="mt-4 pb-0">
          <v-text-field
              v-model="email"
              label="Электронная почта"
              placeholder="name@mail.tld"
              type="email"
              outlined
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text small color="muted" @click="$router.go(-1)">Я передумал</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" large>
            Отправить письмо
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  name: "Reset",
  data: () => ({
    isOpen: true,
    email: ''
  }),
}
</script>

<style scoped>

</style>